import { render, staticRenderFns } from "./BatchModifyHuohao.vue?vue&type=template&id=cfdb99cc&scoped=true"
import script from "./BatchModifyHuohao.vue?vue&type=script&lang=js"
export * from "./BatchModifyHuohao.vue?vue&type=script&lang=js"
import style0 from "./batch-modify.css?vue&type=style&index=0&id=cfdb99cc&prod&scoped=true&lang=css&external"
import style1 from "./BatchModifyHuohao.vue?vue&type=style&index=1&id=cfdb99cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfdb99cc",
  null
  
)

export default component.exports